<template>
  <el-dialog
    v-dialogDrag
    :visible.sync="dialogFrom.dialogVisible"
    v-if="dialogFrom.dialogVisible"
    width="600px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    class="select-template-dialog"
  >
    <div slot="title" class="dialog-title">
      <i class="dialog-title-left-icon" :class="icon" v-if="icon"></i>
      <div class="dialog-title-word">{{ title }}</div>
    </div>
    <div class="container">
      <!-- 搜索框 -->
      <div class="container-search">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="queryParams"
          label-width="5px"
        >
          <el-select
            clearable
            v-model="queryParams.modelType"
            placeholder="类型查询"
            @change="changeType"
          >
            <el-option
              v-for="(value, key) in statusValList"
              :key="key"
              :label="value.showName"
              :value="value.showName"
            >
            </el-option>
          </el-select>
          <el-form-item label="">
            <el-input
              placeholder="请输入内容"
              v-model="queryParams.value"
              class="input-with-select"
              size="small"
              @keyup.enter.native="doSearch"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="doSearch"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 模板列表 -->
      <el-table
        :data="tableData"
        height="300"
        @current-change="handleSelectionChange"
        highlight-current-row
        stripe
        style="text-align: center"
        :header-cell-style="{ background: '#f6f6f6' }"
        border
      >
        <el-table-column label="选择" align="center" width="80">
          <template slot-scope="scope">
            <div class="radio-box">
              <el-radio v-model="multipleSelection" :label="scope.row">{{
                ""
              }}</el-radio>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="modelName" label="模板名称" align="center">
        </el-table-column>
        <el-table-column prop="modelType" label="类型" align="center">
        </el-table-column>
        <el-table-column prop="modelId" label="模板id" align="center">
        </el-table-column>
        <el-table-column
          label="编辑"
          align="center"
          width="80"
          v-if="hasPermiss('print:update')"
        >
          <template slot-scope="scope">
            <div class="radio-box">
              <i
                class="el-icon-edit eliconviews"
                :id="scope.row.modelId"
                @click="handleEdit(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="预览" align="center" width="80">
          <template slot-scope="scope">
            <div class="radio-box">
              <i
                class="el-icon-view eliconviews"
                :id="scope.row.modelId"
                @click="handleView(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="删除"
          align="center"
          width="80"
          v-if="hasPermiss('print:update')"
        >
          <template slot-scope="scope">
            <div class="radio-box">
              <i
                class="el-icon-delete eliconviews"
                :id="scope.row.modelId"
                @click="handleDele(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"   
            @current-change="handleCurrentChange"
            :current-page="queryParams.size"
            :page-sizes="[5, 10, 15, 20]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleOk" size="small"
        >打印预览</el-button
      >
      <el-button
        v-if="hasPermiss('print:update')"
        type="primary"
        @click="handleCreated"
        size="small"
        >新建</el-button
      >

      <el-button @click="handleClose" size="small">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
/**
 * 模板弹出框
 * @property {String} title 弹出框标题
 * @property {String} icon 字体图标
 * @event { Function } handleCreated 新建组件模板
 * @event { Function } handleOk 选择已有模板
 * @event { Function } handleClose 关闭弹出框
 * @event { Function } handleView 预览打印
 */
export default {
  name: "dialogSelect",
  data() {
    return {
      tableData: [], //模板列表数据
      multipleSelection: null, //选择的模板数据
      total: 10, //tableData的总数
      queryParams: {
        //查询条件
        size: 10,
        value: "",
        modelType: "",
      },
      statusValList: [], // 模板类型
    };
  },
  props: {
    // 弹出框title
    title: {
      type: String,
      default: "",
      required: true,
    },
    // 字体图标
    icon: {
      type: String,
      default: "",
    },
    // 页面类型
    modelTypeVal: {
      type: String,
      default: "",
    },
    // 弹窗基本数据
    dialogFrom: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    "dialogFrom.dialogVisible": {
      handler(newName, oldName) {
        if (newName) {
          this.queryParams = {
            size: 10,
            value: "",
            modelType: this.queryParams.modelType || "",
          };
          //获取模板数据
          this.multipleSelection = null;
          // 获取模板类型
          this.$TOOLS
            .getStatusValList("print_model_v3.model_type")
            .then((res) => {
              this.statusValList = res;
            });
          console.log(1);
          this.doSearch();
        }
      },
      immediate: true,
    },
    modelTypeVal: {
      immediate: true,
      handler(newName, oldName) {
        console.log(2);
        console.log("modelTypeVal", newName);
        if (newName) {
          this.queryParams.modelType = newName;
          console.log(
            " this.queryParams.modelType",
            this.queryParams.modelType
          );
          this.doSearch();
        }
      },
    },
  },
  mounted() {},
  methods: {
    // 选择类型
    changeType(e) {
      console.log(e);
      this.queryParams.modelType = e || "";
      this.doSearch();
    },
    //弹框关闭
    handleClose() {
      this.dialogFrom.dialogVisible = false;
    },
    // 单选模板数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取模板列表
    // getData() {
    //   this.$API.getPrintModelList().then((res) => {
    //     this.tableData = res.data.result.data || [];
    //   });
    // },
    // 改变分页的每次调取多少条数据
    handleSizeChange(val) {
      this.queryParams.size = val;
      // 改变后重新调取接口
    },
    // 分页当前页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      // 后面调取接口
    },
    // 选择选中模板
    handleOk() {
      if (!this.multipleSelection) {
        this.$message.warning("请选择模板");
        return;
      }
      // this.dialogFrom.dialogVisible = false;
      this.$emit("handleOk", this.multipleSelection);
    },
    // 条件搜索确认
    doSearch() {
      this.$API
        .getPrintModelList({
          modelName: this.queryParams.value,
          modelType: this.queryParams.modelType,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
        });
    },
    // 新建模板
    handleCreated() {
      this.$emit("handleCreated");
    },
    // 编辑模板
    handleEdit(obj) {
      this.$emit("handleEdit", obj);
    },
    // 预览打印
    handleView(obj) {
      this.$emit("handleView", obj);
    },
    // 删除模板
    handleDele(obj) {
      this.$confirm("确定要把选择的模板进行 删除 操作吗? 请谨慎操作", "提示:").then(() => {
        this.$API.delPrintModel({
          modelId: obj.modelId,
        }).then((res) => {
          if (res.data.status == "success") {
            this.$message.success(res.data.message);
            this.doSearch();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
@mainColor: #ef7c1b;

.select-template-dialog {
  * {
    box-sizing: border-box;
  }
  ::v-deep {
    * {
      box-sizing: border-box;
    }
    .el-dialog {
      border-radius: 6px;
    }
    .el-dialog__header {
      border-radius: 6px 6px 0 0;
      color: #666;
      border-bottom: 1px solid #e9e9e9;
      padding: 12px 20px 12px;
      background-color: #f9f9f9;
    }
    .el-dialog__headerbtn {
      top: 15px;
      font-size: 18px;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-table__cell.gutter {
      background: #f6f6f6;
    }
    .el-dialog__footer {
      justify-content: right;
    }
  }

  .dialog-title {
    display: flex;
    align-items: center;
    height: 24px;
    width: 60%;
  }

  .dialog-title-left-icon {
    font-size: 20px;
    color: @mainColor;
  }

  .eliconviews {
    font-size: 15px;
    color: @mainColor;
    cursor: pointer;
  }

  .dialog-title-word {
    margin-left: 8px;
    font-size: 14px;
  }

  .container {
    .container-search {
      height: 50px;
      align-items: center;
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      ::v-deep {
        .el-form-item {
          margin-bottom: 0;
        }

        .el-form-item__content {
          line-height: normal;
        }
      }
    }
  }
  .radio-box {
    display: flex;
    justify-content: center;
    ::v-deep {
      .el-radio__label {
        display: none;
        padding: 0;
      }
    }
  }
  .pagination {
    margin-top: 20px;
  }
}
</style>